import React from "react";
import "./image.css";

import Image from "../../../../../components/image/image";

class ImageContentBlock extends React.Component {
  render() {
    return (
      <div className="contentBlock image">
        <Image
          src={this.props.url}
          handleImageCreate={this.props.handleImageCreate}
          handleImageLoaded={this.props.handleImageLoaded}
        />
      </div>
    );
  }
}
export default ImageContentBlock;
